import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { ExternalWebhook } from "@rumble-it/common-lib/types/models/ExternalWebhook.interface";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

export const externalWebhookColumns: TableColumnsType<ExternalWebhook> = [
  {
    title: "Titel",
    dataIndex: "title",
    key: "title",
    render: (text: string, record: ExternalWebhook) => (
      <Link to={`/external-webhooks/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: "Method",
    dataIndex: "method",
    key: "method",
  },
  {
    title: "Url",
    dataIndex: "url",
    key: "url",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/external-webhooks/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
